import { useState, useEffect } from "react";

export function useServerGridDataState(apiSubmittedFormData, pageSize = 50) {
  const INITIAL_MAIN_GRID_DATA_STATE = {
    skip: 0,
    take: pageSize,
    sort: [],
    filter: null,
  };

  const [gridDataState, setGridDataState] = useState(
    INITIAL_MAIN_GRID_DATA_STATE
  );

  useEffect(() => {
    //if the apiSubmittedFormData has changed we need to reset grid page to 1, if it is not already set to 1
    if (apiSubmittedFormData && gridDataState) {
      if (gridDataState.skip !== 0) {
        setGridDataState({ ...gridDataState, skip: 0 });
      }
    }
  }, [apiSubmittedFormData]);

  /*
  NOTE: Ahhh jeez I can't intercept the changes here.
  If I try to prevent setGridDataState(), then the "strings in the grid filter itself" won't change.
  To prove this, just comment out the setGridDataState() call.
  */
  const onGridDataStateChange = (e) => {
    setGridDataState(e.dataState);
  };

  return {
    gridDataState,
    onGridDataStateChange,
  };
}
